import {
    /** FETCH APPLICATION  */
    FETCH_LASTAPPLICATIONRESULT_FULFILLED,
    FETCH_LASTAPPLICATIONRESULT_REJECTED,
    FETCH_LASTAPPLICATIONRESULT_PENDING,
    RESET_LASTAPPLICATIONRESULT,
  } from "../../actions/application/lastApplicationResult";
  const initialState = {
    done: false,
    error: false,
    spinner: false
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_LASTAPPLICATIONRESULT_PENDING:
        return {
          done: false,
          spinner: true,
          error: false,
        };
      case FETCH_LASTAPPLICATIONRESULT_FULFILLED:
        return {
          ...state,
          lastApplicationResult: action.payload,
          done: true,
          error: false,
          spinner : false
        };
      case FETCH_LASTAPPLICATIONRESULT_REJECTED:
        return {
          ...state,
          error: action.payload,
          done: false,
          spinner : false
        };
      case RESET_LASTAPPLICATIONRESULT:
        return {
          initialState,
          done: false,
          error: false,
          spinner : false
        };
      default:
        return state;
    }
  };
  